import React from 'react';
import AuthService from './authService';

export default class ExternalSalesPartnerService {
  static async GetList(onlyActive) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/ExternalSalesPartner/GetList/?activeOnly=${onlyActive}&clearCache=true`
    );
  }
}
